import styled from '@emotion/styled';

const Title = styled.div``;

// TODO: Not used
const TitleHolder = styled.div``;
const HeaderContent = styled.div``;

export { HeaderContent, Title, TitleHolder };
